import { QuestelServicesClient, RequestResult } from '@questelservices/common';
import store from '@/store';
import { TypeOfInstruction } from '@/models/TypeOfInstructions/TypeOfInstruction';

export class TypeOfInstructionService {
  private client: QuestelServicesClient;

  constructor() {
    this.client = new QuestelServicesClient(store, "/api");
  }

  public async getTypeOfInstructionList(): Promise<TypeOfInstruction[]> {
    return await this.client.get<TypeOfInstruction[]>(`/v1/TypeOfInstruction`);
  }
}